import { GetStaticProps } from 'next'
import { NextSeo } from 'next-seo'

import { AdditionalPageNav } from 'sections/common'
import { MeetTheTeamPage, strapi } from 'api'
import { REVALIDATION_TIMEOUT } from 'const/config'
import { JoinSection } from 'sections/meet-the-team-page'
import { TeamPerson } from 'api/strapi/teams/types'
import { Team } from 'components/team-members'

interface MeetTheTeamProps {
  pageInfo: MeetTheTeamPage
  people: TeamPerson[]
}

export default function MeetTheTeam({ pageInfo, people }: MeetTheTeamProps) {
  const {
    welcome_content,
    welcome_title,
    join_section_title,
    join_section_content,
    team_section_content,
    team_section_title,
    team_section_subtitle,
  } = pageInfo

  return (
    <>
      <NextSeo title="Meet The Team" />

      <AdditionalPageNav
        page="meetTheTeam"
        welcomeContent={welcome_content}
        welcomeContentTitle={welcome_title}
      />
      <Team
        people={people}
        content={team_section_content}
        title={team_section_title}
        subtitle={team_section_subtitle}
      />
      <JoinSection title={join_section_title} content={join_section_content} />
    </>
  )
}

export const getStaticProps: GetStaticProps<MeetTheTeamProps> = async () => {
  const pageInfo = await strapi.pages.meetTheTeam()
  const { items } = await strapi.teams.find({})

  return {
    revalidate: REVALIDATION_TIMEOUT,
    props: {
      pageInfo,
      people: items,
    },
  }
}
